import Vue from "vue";
import { cancelAllRequests, refreshToken } from "@/services/Api";
import Router from "vue-router";
import store from "./store/index";

function lazyLoadViewFiles(view) {
  return () => import(`@/views/${view}.vue`);
}

function basicAuth(to, from, next) {
  // Blocking if it exceeds 90 days without changing password
  if (store.getters.getGeneralState("isPasswordUpdateSkip")) {
    if (
      store.getters.getGeneralState("userData").role == "super-admin" ||
      !store.getters.isPlantExpired(store.getters.getSelectedPlantId)
    ) {
      next(true);
    } else {
      next(false);
    }
  } else {
    next({ name: "setPassword" });
  }
}

function checkingIsPasswordValid(to, from, next) {
  // Blocking if it exceeds 90 days without changing password
  if (store.getters.getGeneralState("isPasswordUpdateSkip")) {
    next(true);
  } else {
    next({ name: "setPassword" });
  }
}

function passwordRenewAuth(to, from, next) {
  // Blocking if it exceeds 90 days without changing password
  if (store.getters.getGeneralState("isPasswordUpdateSkip")) {
    next();
  } else {
    next({ name: "setPassword" });
  }
}

function roleAuth(to, from, next) {
  // Blocking configuration paths if role is not admin
  if (store.getters.getGeneralState("isPasswordUpdateSkip")) {
    if (
      store.state &&
      store.state.userData &&
      (store.state.userData.role === "admin" ||
        store.state.userData.role === "super-admin")
    ) {
      next(true);
    } else {
      next(false);
    }
  } else {
    next({ name: "setPassword" });
  }
}

function advRoleAuth(to, from, next) {
  // Blocking configuration paths if role is not super-admin
  if (store.getters.getGeneralState("isPasswordUpdateSkip")) {
    if (
      store.state &&
      store.state.userData &&
      store.state.userData.role === "super-admin"
    ) {
      next(true);
    } else {
      next(false);
    }
  } else {
    next({ name: "setPassword" });
  }
}

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: "*",
      meta: {
        public: true,
      },
      redirect: {
        name: "404",
      },
    },
    {
      path: "/404",
      name: "404",
      component: lazyLoadViewFiles("Deny"),
    },
    {
      path: "/splash",
      name: "splash",
      component: lazyLoadViewFiles("SplashScreen"),
    },
    {
      alias: "/",
      path: "/login",
      name: "login",
      component: lazyLoadViewFiles("Login"),
      beforeEnter: passwordRenewAuth,
    },
    {
      path: "/set-password",
      name: "setPassword",
      component: lazyLoadViewFiles("SetPassword"),
    },
    {
      path: "/session-management/:info",
      name: "sessionManagement",
      component: lazyLoadViewFiles("SessionManagement"),
    },
    // user routes
    {
      path: "",
      component: lazyLoadViewFiles("Container"),
      children: [
        {
          path: "/home",
          name: "home",
          component: lazyLoadViewFiles("Home"),
          beforeEnter: checkingIsPasswordValid,
        },
        {
          path: "/think-home",
          alias: "/ThinkHome",
          name: "thinkHome",
          component: lazyLoadViewFiles("ThinkHome"),
          beforeEnter: checkingIsPasswordValid,
        },
        {
          path: "/plantOverview",
          name: "plantOverview",
          component: lazyLoadViewFiles("PlantOverviewNew"),
          beforeEnter: basicAuth,
        },
        {
          path: "/report",
          name: "report",
          component: lazyLoadViewFiles("Report"),
          beforeEnter: basicAuth,
        },
        {
          path: "/battery",
          name: "battery",
          component: lazyLoadViewFiles("Battery"),
          beforeEnter: basicAuth,
        },
        {
          path: "/notification",
          name: "notification",
          component: lazyLoadViewFiles("Notification"),
          beforeEnter: basicAuth,
        },       
        // user routes
        {
          path: "/pvsyst-upload",
          name: "PvsystUpload",
          component: lazyLoadViewFiles("PvsystUpload"),
          beforeEnter: basicAuth,
        },
        {
          path: "/inverter-status",
          alias: "/inverterStatus",
          name: "inverterStatus",
          component: lazyLoadViewFiles("InverterStatus"),
          beforeEnter: basicAuth,
        },
        {
          path: "",
          component: lazyLoadViewFiles("DashboardContainer"),
          name: "DashboardContainer",
          children: [
            {
              path: "/inverter",
              name: "inverter",
              component: lazyLoadViewFiles("Inverter"),
              beforeEnter: basicAuth,
            },
            {
              path: "/pcs",
              name: "pcs",
              component: lazyLoadViewFiles("PCS"),
              // beforeEnter: basicAuth,
            },
            {
              path: "/weather-station",
              alias: "/weather_station",
              name: "weatherStation",
              component: lazyLoadViewFiles("WS"),
              beforeEnter: basicAuth,
            },
            {
              path: "/relay",
              name: "relay",
              component: lazyLoadViewFiles("Relay"),
              beforeEnter: basicAuth
            },
            {
              path: "/scbs",
              name: "advancedScb",
              component: lazyLoadViewFiles("SCBS"),
              beforeEnter: basicAuth,
            },
            {
              path: "/nifps",
              name: "nifps",
              component: lazyLoadViewFiles("NIFPS"),
              beforeEnter: basicAuth,
            },
            {
              path: "/tracker",
              name: "tracker",
              component: lazyLoadViewFiles("Tracker"),
              beforeEnter: basicAuth,
            },
            {
              path: "/fire-alarm",
              name: "fireAlarm",
              component: lazyLoadViewFiles("FireAlarm"),
              beforeEnter: basicAuth,
            },
            {
              path: "/annunciator",
              name: "annunciator",
              component: lazyLoadViewFiles("Annunciator"),
              beforeEnter: basicAuth
            },
            {
              path: "/zmu",
              name: "zmuMonitoring",
              component: lazyLoadViewFiles("ZMU"),
              beforeEnter: basicAuth,
            },
            {
              path: "/string-inverter",
              alias: "/stringInverter",
              name: "stringInverter",
              component: lazyLoadViewFiles("StringInverter"),
              beforeEnter: basicAuth,
            },
            {
              path: "/advanced-string-inverter",
              alias: "/advancedStringInverter",
              name: "advancedStringInverter",
              component: lazyLoadViewFiles("AdvancedStringInverter"),
              beforeEnter: basicAuth,
            },
            {
              path: "/zone",
              name: "zone-monitoring",
              component: lazyLoadViewFiles("ZoneMonitoring"),
              beforeEnter: basicAuth,
            },
            {
              path: "/mfm",
              name: "mfm",
              component: lazyLoadViewFiles("MFM"),
              beforeEnter: basicAuth,
            },
            {
              path: "/lms",
              name: "lms",
              component: lazyLoadViewFiles("LoadManager"),
              props: { mode: 'lms' },
              beforeEnter: basicAuth,
            },
            {
              path: "/zes",
              name: "zes",
              component: lazyLoadViewFiles("LoadManager"),
              props: { mode: 'zes' },
              beforeEnter: basicAuth,
            },
            {
              path: "/custom-report",
              alias: "/customReport",
              name: "custom-report",
              component: lazyLoadViewFiles("CustomReport"),
              beforeEnter: basicAuth,
            },
            {
              path: "/live-dash",
              alias: "/liveDash",
              name: "liveDash",
              component: lazyLoadViewFiles("LiveDash"),
              beforeEnter: basicAuth,
            },
            {
              path: "/alert",
              name: "alert",
              component: lazyLoadViewFiles("AlertMiddleware"),
              beforeEnter: basicAuth,
            },
            {
              path: "/plant-analytics",
              name: "plantAnalytics",
              component: lazyLoadViewFiles("PlantAnalytics"),
              beforeEnter: basicAuth,
            },
            {
              path: "/down-time-analysis",
              name: "downTimeAnalysis",
              component: lazyLoadViewFiles("DownTimeAnalysis"),
              beforeEnter: basicAuth,
            },
            {
              path: "/forecast",
              name: "forecast",
              component: lazyLoadViewFiles("Forecast"),
              beforeEnter: basicAuth,
            },
            {
              path: "/pvsystExpected",
              name: "pvsystExpected",
              component: lazyLoadViewFiles("pvsystExpected"),
              beforeEnter: basicAuth
            },
            {
              path: "/other-sensors",
              name: "otherSensors",
              component: lazyLoadViewFiles("OtherSensors"),
              beforeEnter: basicAuth,
            },
            {
              path: "/inverter-ranking",
              name: "inverterRanking",
              component: lazyLoadViewFiles("InverterRanking"),
              beforeEnter: basicAuth,
            },
          ],
        },
        {
          path: "/custom-report-config",
          alias: "/customReportConfig",
          name: "customReportConfig",
          component: lazyLoadViewFiles("CustomReportConfig"),
          beforeEnter: basicAuth,
        },
        {
          path: "/plant-detail",
          alias: "/plantDetail",
          name: "plantDetail ",
          component: lazyLoadViewFiles("PlantDetail"),
          beforeEnter: basicAuth,
        },
        {
          path: "/string-evaluation",
          alias: "/stringEvaluation",
          name: "/stringEvaluation",
          component: lazyLoadViewFiles("StringEvaluation"),
          beforeEnter: basicAuth,
        },
        {
          path: "/temp-pr",
          alias: "/tempPr",
          name: "pr",
          component: lazyLoadViewFiles("TempBasedPr"),
          beforeEnter: basicAuth,
        },
        {
          path: "/device-control",
          alias: "/deviceControl",
          name: "deviceControl",
          component: lazyLoadViewFiles("controlling/DeviceControl"),
          beforeEnter: basicAuth,
        },
        {
          path: "/inverter-control",
          alias: "/inverterControl",
          name: "inverterControl",
          component: lazyLoadViewFiles(
            "controlling/SBEControl/InverterControl"
          )
        },
        {
          path: "/device-control-v2",
          alias: "/deviceControlV2",
          name: "deviceControlV2",
          component: lazyLoadViewFiles("controlling/DeviceControlV2"),
          beforeEnter: basicAuth,
        },
        {
          path: "/inverter-control-v2",
          alias: "/inverterControlV2",
          name: "inverterControlV2",
          component: lazyLoadViewFiles("InverterControlV2"),
          beforeEnter: basicAuth,
        },
        {
          path: "/sld",
          name: "sld",
          component: lazyLoadViewFiles("SLD"),
          beforeEnter: basicAuth,
        },
        {
          path: "/communication-diagram",
          name: "communicationDiagram",
          component: lazyLoadViewFiles("CommunicationDiagram"),
          beforeEnter: basicAuth,
        },
        {
          path: "/dgr",
          name: "dgr",
          component: lazyLoadViewFiles("DGR"),
          beforeEnter: basicAuth,
        },
        {
          path: "/general/*",
          name: "componentCard",
          component: lazyLoadViewFiles("StaticInfo"),
          beforeEnter: basicAuth,
        },
        {
          path: "/upload-docs",
          name: "uploadDocument",
          // Adjust
          component: lazyLoadViewFiles("StaticDocs"),
          beforeEnter: basicAuth,
        },
        {
          path: "/zmu-docs",
          name: "uploadZmuDocument",
          // Adjust
          component: lazyLoadViewFiles("ZmuDocs"),
          beforeEnter: basicAuth,
        },
        {
          path: "/String-monitoring",
          alias: "/StringMonitoring",
          name: "stringMonitoring",
          component: lazyLoadViewFiles("StringMonitoring"),
          beforeEnter: basicAuth,
        },
        {
          path: "/revenue-report",
          name: "Revenue Report",
          component: lazyLoadViewFiles("RevenueReport"),
          beforeEnter: basicAuth,
        },
        {
          path: "/technical-reports",
          name: "technicalReports",
          component: lazyLoadViewFiles("tepReport/TechnicalReport"),
          beforeEnter: basicAuth,
        },
        {
          path: "/management-reports",
          name: "managementReports",
          component: lazyLoadViewFiles("tepReport/ManagementReport"),
          beforeEnter: basicAuth,
        },
        {
          path: "/deemed-reports",
          name: "deemedReports",
          component: lazyLoadViewFiles("tepReport/DeemedReport"),
          beforeEnter: basicAuth,
        },
        {
          path: "/monthly-technical-report",
          name: "monthlyTechnicalReport",
          component: lazyLoadViewFiles("tepReport/MonthlyTechnicalReport"),
          beforeEnter: basicAuth,
        },
        {
          path: "/time-sync",
          name: "timeSync",
          component: lazyLoadViewFiles("GpsTime"),
          beforeEnter: basicAuth,
        },
        {
          path: "/admin-control",
          alias: "/adminControl",
          name: "adminControl",
          component: lazyLoadViewFiles("AdminControl"),
          beforeEnter: basicAuth,
        },
        {
          path: "/archive",
          name: "archive",
          component: lazyLoadViewFiles("Archive"),
          beforeEnter: basicAuth,
        },
      ],
    },
    // admin routes
    {
      path: "/admin",
      name: "adminContainer",
      component: lazyLoadViewFiles("Container"),
      children: [
        // Manual Report
        {
          path: "custom-alert",
          alias: "customAlert",
          name: "customAlert",
          component: lazyLoadViewFiles("admin/CustomAlert"),
          beforeEnter: advRoleAuth,
        },
        {
          path: "/poa-config",
          alias: "/poaConfig",
          name: "poaConfig",
          component: lazyLoadViewFiles("admin/PoaConfig"),
          beforeEnter: roleAuth,
        },
      ],
    },
    {
      path: "/ics-admin",
      name: "ics admin",
      component: lazyLoadViewFiles("Container"),
      children: [
        // Admin Module
        {
          path: "",
          name: "ics-admin-tool",
          component: lazyLoadViewFiles("icsAdmin/Admin"),
          beforeEnter: roleAuth,
        },
        {
          path: "analytics-config/",
          alias: "analyticsConfig",
          name: "icsAnalyticsConfig",
          component: lazyLoadViewFiles("icsAdmin/analytics/AnalyticsDevice"),
          beforeEnter: roleAuth,
        },
        {
          path: "report-config/",
          alias: "reportConfig",
          name: "icsReportConfig",
          component: lazyLoadViewFiles("icsAdmin/reports/ReportsDevice"),
          beforeEnter: roleAuth,
        },
        {
          path: "plant-config/",
          alias: "plantConfig",
          name: "icsPlantConfig",
          component: lazyLoadViewFiles("icsAdmin/plant/PlantDevice"),
          beforeEnter: roleAuth,
        },
      ],
    },
  ],
});

function removeZohoScripts() {
  const zohoScript = document.getElementById("zoho-help");
  const extraScript = document.getElementById("zohohc-asap-web-helper-main");

  if (zohoScript) {
    zohoScript.src = '';
    zohoScript.remove();
  }
  if (extraScript) {
    extraScript.src = '';
    extraScript.remove();
  }
}

function addZohoScript() {
  if (!document.getElementById("zoho-help")) {
    const scriptElement = document.createElement("script");
    scriptElement.setAttribute("id", "zoho-help");
    scriptElement.type = "text/javascript";
    scriptElement.nonce = "{your_nonce_value}";
    scriptElement.src = "https://desk.zoho.com/portal/api/web/inapp/191369000016859059?orgId=647260008";
    scriptElement.defer = true;
    document.body.appendChild(scriptElement);
  }
}

// Set up observer only once
let observer = null;

router.beforeEach((to, from, next) => {
  const removeZohoIconFor = ['login', 'setPassword', 'unblockAccount', 'sessionManagement', '404', 'splash'];

  if (removeZohoIconFor.includes(to.name)) {
    removeZohoScripts();
  } else {
    Vue.nextTick(() => {
      addZohoScript();

      if (!observer) {
        observer = new MutationObserver((mutations, obs) => {
          if (document.getElementById("zoho-help")) {
            obs.disconnect(); // Stop observing once the script is added
            observer = null; // Cleanup reference
          }
        });

        // Observe only the `body` for new script elements
        observer.observe(document.body, { childList: true });
      }
    });
  }

  next();
});

router.afterEach((to, from) => {
  cancelAllRequests();
  refreshToken();
});

export default router;
